export const CHECKOUT_SUCCESS = "CHECKOUT_SUCCESS"
export const CHECKOUT_FAILED = "CHECKOUT_FAILED"